export enum LineStatus {
    PENDING = "PEN",
    ACCEPTED = "ACC",
    DENIED = "DEN",
    BACKORDER = "BO",
    PARTSHIPPED = "PRTS",
    PENDINGRETURN = "PR"
};

export enum ClaimStatus {
    ACCEPTED = "ACC",
    INITIATED = "INI",
    DENIED = "DEN",
    CLOSED = "CLO"
}